import { Subject } from 'rxjs';
import { share } from 'rxjs/operators';
import * as i0 from "@angular/core";
var SpinnerService = /** @class */ (function () {
    function SpinnerService() {
        this.subject = new Subject();
        this.change = this.subject.asObservable().pipe(share());
        this.current = {
            mode: "indeterminate",
            value: 0
        };
    }
    SpinnerService.prototype.block = function () {
        this.update(true, this.current);
    };
    SpinnerService.prototype.unblock = function () {
        this.update(false, this.current);
    };
    SpinnerService.prototype.update = function (show, settings) {
        this.subject.next({ show: show, settings: settings });
    };
    SpinnerService.ngInjectableDef = i0.defineInjectable({ factory: function SpinnerService_Factory() { return new SpinnerService(); }, token: SpinnerService, providedIn: "root" });
    return SpinnerService;
}());
export { SpinnerService };
